

export const formatDate = (date: Date | string, barType: string = '/'): string | null => {
  if (!date) return null
  const newDate = new Date(date)
  const day = newDate.getDate().toString().padStart(2, '0');
  const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
  const year = newDate.getFullYear();

  const formattedDate = `${day}${barType}${month}${barType}${year}`;

  return formattedDate
}

export const formatSimpleDate = (date: string | string, barType: string = '/'): string | null => {
  console.log(date);
  const splitDate = date.split('-');
  const reformatedDate = `${splitDate[2]}${barType}${splitDate[1]}${barType}${splitDate[0]}`
  return reformatedDate;
}